import ProductAllocation from '../pages/ProductAllocation';

const productAllocationRoute = {
  public: [],
  auth: [
    {
      name: 'product_allocation',
      path: '/maintenance/product-allocation',
      permissions: ['PM', 'GPM'],
      component: ProductAllocation,
    },
  ],
};

export default productAllocationRoute;
